import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'anf-core-react';
import CheckoutPageContext from '../../context/CheckoutPageContext';

function ContinueButton({
  onContinue, step, isEditing, stepId, isEnabled, isStepProcessing, userExists,
}) {
  const { checkoutPageState } = useContext(CheckoutPageContext) || {};
  const textFor = checkoutPageState?.textFor;

  // Determine button label based on editing state and available text sources
  const getButtonLabel = () => {
    // If user exists, show "SignIn Prompt" with Continue as Guest button
    if (userExists && step?.continueAsGuestLabel?.value) {
      return textFor?.[step?.continueAsGuestLabel?.key]?.value
      || step.continueAsGuestLabel.value
      || textFor?.continueAsGuestButton?.value
      || 'Continue as Guest';
    }

    if (isEditing) {
      // For editing state, prioritize textFor, then step config, then fallback
      return textFor?.[step?.updateButtonLabel?.key]?.value
        || step?.updateButtonLabel?.value
        || textFor?.updateButton?.value
        || 'Update';
    }
    // For continue state, prioritize textFor, then step config, then fallback
    return textFor?.[step?.nextButtonLabel?.key]?.value
        || step?.nextButtonLabel?.value
        || textFor?.continueButton?.value
        || 'Continue';
  };

  const label = getButtonLabel();

  return (
    <div data-testid={`continue-button-${stepId}`}>
      <Button
        variant="secondary"
        onClick={onContinue}
        isDisabled={!isEnabled}
        isProcessing={isStepProcessing}
      >
        {label}
      </Button>
    </div>
  );
}

ContinueButton.propTypes = {
  onContinue: PropTypes.func.isRequired,
  step: PropTypes.shape({
    nextButtonLabel: PropTypes.shape({ key: PropTypes.string, value: PropTypes.string }),
    updateButtonLabel: PropTypes.shape({ key: PropTypes.string, value: PropTypes.string }),
    continueAsGuestLabel: PropTypes.shape({ key: PropTypes.string, value: PropTypes.string }),
  }).isRequired,
  isEditing: PropTypes.bool,
  stepId: PropTypes.string.isRequired,
  isEnabled: PropTypes.bool.isRequired,
  isStepProcessing: PropTypes.bool.isRequired,
  userExists: PropTypes.bool,
};

ContinueButton.defaultProps = {
  isEditing: false,
  userExists: false,
};

export default ContinueButton;
